import { create } from 'zustand'

import { get as apiGet } from '@/api/request'
import type { Farm } from '@/types/api'

interface FarmsStore {
  farms: Farm[]
  isLoading: boolean
  error: string | null
  _initialized: boolean
  fetch: () => Promise<void>
  reset: () => void
}

export const useFarmsStore = create<FarmsStore>((set, get) => ({
  farms: [],
  isLoading: false,
  error: null,
  _initialized: false,

  async fetch() {
    if (!get()._initialized) {
      set({ isLoading: true, error: null })
    }
    try {
      const res = await apiGet<{ farms: Farm[] }>('/farms')
      if (res.data?.data) {
        set({ farms: res.data.data.farms, error: null })
      }
    } catch (err) {
      if (!get()._initialized) {
        set({ error: err instanceof Error ? err.message : 'Failed' })
      }
    } finally {
      set({ isLoading: false, _initialized: true })
    }
  },

  reset() {
    set({ farms: [], isLoading: false, error: null, _initialized: false })
  },
}))
